import { render, staticRenderFns } from "./matching.vue?vue&type=template&id=93bdb5a8&scoped=true&"
import script from "./matching.vue?vue&type=script&lang=js&"
export * from "./matching.vue?vue&type=script&lang=js&"
import style0 from "./matching.vue?vue&type=style&index=0&id=93bdb5a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93bdb5a8",
  null
  
)

export default component.exports